module.exports = __webpack_public_path__ + "static/img/webpic004.df50f85.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/webpic004.jpg
// module id = aDSL
// module chunks = 1